package com.essntl.features.invoice.ui.addeditinvoice.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.unit.dp
import com.essntl.config.EssntlConfig
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.secondary.EsSmallSecondaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun QuickbooksRefreshWebpageDialog(
    onDismissRequest: () -> Unit,
) {
    val uriHandler = LocalUriHandler.current
    val clipboardManager = LocalClipboardManager.current

    var isLoginLinkOpened by remember {
        mutableStateOf(false)
    }

    EsDialog(
        title = "Quickbooks Authorization",
        onDismissRequest = onDismissRequest,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(2.spacing),
            modifier = Modifier
                .padding(20.dp)
        ) {
            if (isLoginLinkOpened) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(2.spacing),
                ) {
                    Text(
                        text = "Redirecting to Quickbooks for authorization...",
                        style = MaterialTheme.esTypography.p1Regular16,
                        color = MaterialTheme.esColorScheme.textPrimary,
                    )

                    EsSpinner()
                }

                Text(
                    text = "If you are not redirected, click the button below.",
                    style = MaterialTheme.esTypography.p2Regular14,
                    color = MaterialTheme.esColorScheme.textPrimary,
                )

                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(2.spacing),
                ) {
                    EsSmallSecondaryButton(
                        onClick = {
                            uriHandler.openUri(EssntlConfig.quickbooksRefreshTokenUrl)
                        },
                        text = "Login with Quickbooks",
                    )

                    Text(
                        text = "or",
                        style = MaterialTheme.esTypography.p2Regular14,
                        color = MaterialTheme.esColorScheme.textPrimary,
                    )

                    EsSmallSecondaryButton(
                        onClick = {
                            clipboardManager.setText(AnnotatedString(EssntlConfig.quickbooksRefreshTokenUrl))
                        },
                        text = "Copy to clipboard",
                    )
                }
            } else {
                EsLargePrimaryButton(
                    onClick = {
                        uriHandler.openUri(EssntlConfig.quickbooksRefreshTokenUrl)

                        isLoginLinkOpened = true
                    },
                    text = "Login with Quickbooks",
                )
            }
        }
    }
}